import cx from 'classnames'
import { Check02 } from 'blaze-ui/icons/16'
import { VisualStyle } from 'types'
import Styles from './VisualStyleCard.module.scss'
import { ImageX } from 'blaze-ui/icons/20/ImageX'

export interface VisualStyleCardProps {
  style: VisualStyle | null
  isSelected: boolean
  onSelect: () => void
}

export const VisualStyleCard = ({ style, isSelected, onSelect }: VisualStyleCardProps) => {
  return (
    <div className={cx(Styles.card, { [Styles.selected]: isSelected })} onClick={onSelect}>
      {style ? (
        <img src={style.cover_image_url} alt={style.name} className={Styles.image} />
      ) : (
        <div className={Styles.noImage}>
          <ImageX size={40} color="var(--dark-40)" />
        </div>
      )}
      <div className={cx(Styles.label, { [Styles.selectedLabel]: isSelected, [Styles.noVisualStyle]: style === null })}>
        {style?.name ?? 'No Visual Style'}
      </div>
      {isSelected && (
        <div className={Styles.checkbox}>
          <Check02 size={12} color="var(--dark-80)" />
        </div>
      )}
    </div>
  )
}

export const VisualStyleCardSkeleton = () => {
  return <div className={cx(Styles.card, Styles.loading)} />
}
